<template>
  <div class="overflow-hidden ">
    <div v-if="!showError">

      <div style="height:100%" v-if="loading">
        <loader size="xxs" :loader-image="false" />
      </div>
      <div v-else class="payPreference flex flex-col gap-[24px]">

        <div v-if="!editPayPreference" class="cursor-pointer bg-dynamicBackBtn text-white px-3 py-2 font-bold flex items-center gap-2 ml-auto rounded text-sm" @click="editPayPreferencePrivilege">
          <Icon icon-name="edit" size="xs" class=" text-white" style="fill: transparent;"/>
          Edit Preferences
        </div>
        <div v-else class="cursor-pointer bg-dynamicBackBtn text-white px-3 py-2 font-bold flex items-center gap-2 ml-auto rounded text-sm" @click="cancelChanges">
          <Icon icon-name="close-icon" size="xs" class=" text-white" style="fill: transparent;"/>
          Cancel Changes
        </div>


        <!-- Payslips Section -->
        <PayslipSection :payslip-settings="payslipSettings" :can-edit="editPayPreference" @update="updateSetting('payslipSettings', $event)" />

        <!-- Payslip Notifications Section -->
        <PayslipNotificationSection :notification-settings="notificationSettings" :can-edit="editPayPreference"
          @update="updateSetting('notificationSettings', $event)" />

        <!-- Payroll Reporting Section -->
        <PayrollReporting :report-data-headers="reportDataHeaders" :can-edit="editPayPreference" @update="updateSetting('reportDataHeaders', $event)" />

        <div v-if="editPayPreference" class="flex flex-row justify-end items-center">
          <Button class=" bg-dynamicBackBtn text-white buttons "
          :disabled="loading" @click="saveSettings">
          Save
        </Button>


        <Button class="cancel-button inline-block text-[#321C3B] rounded-md"
        :disabled="loading" @click="cancelChanges">
        Cancel
      </Button>
        </div>

      </div>

    </div>
    <div v-else>
      <error-page />
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
import Loader from "@/components/Loader";
import ErrorPage from "@/modules/Admin/error403";
import Icon from "@/components/Icon";
import PayslipSection from './Payslip';
import PayslipNotificationSection from './PayslipNotification';
import PayrollReporting from './PayrollReporting';

export default {
  components: {
    PayslipSection,
    PayslipNotificationSection,
    Loader,
    Button,
    PayrollReporting,
    ErrorPage,
    Icon,
  },
  data() {
    return {
      showError: false,
      loading: false,
      payslipSettings: {},
      notificationSettings: {},
      reportDataHeaders: [],
      editPayPreference: false,
    };
  },
  methods: {
    async editPayPreferencePrivilege() {
      try {
        await this.$handlePrivilege("paySettings", "editPayPreference");
        this.editPayPreference = true;
      } catch (error) {
        this.$toasted.error('you do not have permission to edit pay preference', {
          duration: 5000
        });
        this.editPayPreference = false;
      }
    },
    async getPayPrefrences() {
      this.loading = true;
      try {
        await this.$_getPayPreferences().then(result => {
          const { payPreference, reportData } = result.data.data;
          this.payslipSettings = {
            generateOnApproval: payPreference?.generateOnApproval,
            generateOnPaid: payPreference?.generateOnPaid,
          };
          this.notificationSettings = {
            inAppNotification: payPreference?.inAppNotification,
            emailNotification: payPreference?.emailNotification,
          };
          this.reportDataHeaders = Array.isArray(reportData) ? reportData.map(item => ({
            fieldName: item.fieldName,
              status: item.status
            })) : Object.values(reportData).map(item => ({
              fieldName: item.fieldName,
              status: item.status
            }))
          this.loading = false
        });

      } catch (error) {
        this.$toasted.error(error, {
          duration: 5000
        });
      }
    },
    async saveSettings() {
      this.loading = true;
      const payload = {
        ...this.payslipSettings,
        ...this.notificationSettings,
        reportDataHeaders: Object.values(this.reportDataHeaders)
      };
      try {
        await this.$_savePayPreferences(payload);
        this.$toasted.success('Preferences saved successfully', { duration: 3000 });
        this.editPayPreference = false;
        this.loading = false;
      } catch (error) {
        this.$toasted.error(error, {
          duration: 5000
        });
        this.loading = false
      }
    },
    cancelChanges() {
      this.editPayPreference = false;
      this.getPayPrefrences();
    },
    updateSetting(settingType, newSettings) {
      if (newSettings) {
        this[settingType] = { ...this[settingType], ...newSettings };
      }
    },
  },
  async mounted() {
    try {
      await this.$handlePrivilege("paySettings", "viewPayPreference");
    } catch (error) {
      this.showError = true;
    }
    this.getPayPrefrences();
  },
};
</script>

<style scoped>
.payPreference {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 32px;
}



.save-button {
  width: max-content;
}

.save-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
</style>
